import * as React from "react";
import { IRoamingInternationalCountry } from "@nju/data-access-portal-dashboard";
import { IOffer } from "@nju/data-access-portal-offers";
import { Separator, Text } from "@nju/ui";
import { Packages } from "../packages";
import { SelectedCountryDetails } from "../partials";
import { Switcher } from "../partials/Switcher";
import { IButtonType, IFilteredOffer, IPackageType } from "../types";
import { groupOffersByPromoZone } from "./utils";

interface IOfferWithPromoProps {
  selectedCountry: IRoamingInternationalCountry;
  promoRoamingOffers: IFilteredOffer;
  selectedVoicePackage: IOffer | undefined;
  selectedDataPackage: IOffer | undefined;
  roamingOffers: IFilteredOffer;
  onSelectVoicePackage: (type: IButtonType, packageType: IPackageType) => void;
  onSelectDataPackage: (type: IButtonType, packageType: IPackageType) => void;
  onSetDefaultPackages: (packageType: IPackageType) => void;
  packageType: IPackageType;
  setPackageType: (packageType: IPackageType) => void;
}

export function OfferPromo({
  selectedCountry,
  roamingOffers,
  promoRoamingOffers,
  selectedVoicePackage,
  selectedDataPackage,
  onSelectVoicePackage,
  onSelectDataPackage,
  onSetDefaultPackages,
  packageType,
  setPackageType,
}: IOfferWithPromoProps) {
  const showSwitcher =
    promoRoamingOffers.dataPackage.length > 0 ||
    promoRoamingOffers.voicePackage.length > 0;

  const handleSetPackageType = React.useCallback(
    (packageType: IPackageType) => {
      onSetDefaultPackages(packageType);
      setPackageType(packageType);
    },
    [onSetDefaultPackages, setPackageType],
  );

  const groupedOffers = groupOffersByPromoZone(promoRoamingOffers);

  return (
    <>
      {showSwitcher && (
        <Switcher
          packageType={packageType}
          setPackageType={handleSetPackageType}
          testId="roaming-package-type-switcher"
        />
      )}
      <Separator size="xs" tone="invisible" />
      <SelectedCountryDetails
        packageType={packageType}
        selectedCountry={selectedCountry}
        withRoamingZone={packageType === "STANDARD" ? true : false}
      />
      {packageType === "STANDARD" && <Separator size="s" tone="invisible" />}
      {packageType === "PROMO" && (
        <>
          {groupedOffers.map((item, index) => {
            return (
              <>
                {index === 1 && <Separator />}
                <Text
                  className={`mb-4 ${index === 1 ? "mt-6" : ""}`}
                  display="block"
                  size={{
                    "@fromTablet": "keySM",
                    "@onlyMobile": "xl",
                  }}
                  tone="accent"
                  weight="bold"
                >
                  {
                    selectedCountry.zones.find((zone) => {
                      return item.zone === zone.name;
                    })?.displayName.pl
                  }
                </Text>
                {item.zone === "HT" && (
                  <Text
                    className="mb-4"
                    display="block"
                    size={{ "@onlyMobile": "s", "@fromTablet": "l" }}
                  >
                    W ramach tej strefy, z pakietu możesz korzystać jeszcze w
                    wielu innych krajach.
                  </Text>
                )}
                <Packages
                  offers={item}
                  onSelectDataPackage={onSelectDataPackage}
                  onSelectVoicePackage={onSelectVoicePackage}
                  packageType="PROMO"
                  selectedDataPackage={selectedDataPackage}
                  selectedVoicePackage={selectedVoicePackage}
                />
                <Separator tone="invisible" />
              </>
            );
          })}
        </>
      )}
      {packageType === "STANDARD" && (
        <Packages
          offers={roamingOffers}
          onSelectDataPackage={onSelectDataPackage}
          onSelectVoicePackage={onSelectVoicePackage}
          packageType="STANDARD"
          selectedDataPackage={selectedDataPackage}
          selectedVoicePackage={selectedVoicePackage}
        />
      )}
    </>
  );
}
